import DatabaseModel from './DatabaseModel.js';

var ExpedienteCambio = Object.create(DatabaseModel);

ExpedienteCambio.model = 'expedientecambio';
ExpedienteCambio.modelFront = 'expedientecambio';



export default ExpedienteCambio;